module.exports = __webpack_public_path__ + "img/Market brakedown by advertised price.b4ae25e0.jpg";